import {
    isLoadingProjects,
    DefaultProjectLoadState,
    getDefaultProjectLoadState,
} from 'owa-timestream-store';
/**
 * Checks to see if the default calendar board project is being created or loading.
 * @returns true if the default calendar board project is creating or loading, false otherwise.
 */
export default function isLoadingCalendarBoardProject(): boolean {
    const projectLoadState = getDefaultProjectLoadState();

    // if project is being created, show loading view
    if (projectLoadState === DefaultProjectLoadState.Creating) {
        return true;
    }

    // if project fails to load or create, return false so we render network error
    if (
        projectLoadState === DefaultProjectLoadState.ErrorCreateNew ||
        projectLoadState == DefaultProjectLoadState.ErrorLoadExisting
    ) {
        return false;
    }

    return isLoadingProjects();
}
